import React from 'react';
import { Button, Modal, Toast, Badge } from 'antd-mobile';
import {post} from '../../utils/request';
import { href } from '../../utils/util';
import logoImg from './image/logo.png';
import contentImg from './image/content.png';
import cookies from 'js-cookie';
import InvitationLogin from '../modules/login';
import { wxfx } from '../../utils/wxfx.js';
import api from './api';

import './index.less';

class InvitationOpen extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            loginType: false,
            mobile: ''
        };
    }

    componentDidMount() {
        if(window.location.hash.indexOf('?mobile=') > -1){
            this.setState({
                mobile: window.location.hash.split('?mobile=')[1]
            },()=>{
                this.fx();
            });
        }
        if(cookies.get('session_key')){
            post({
                url: api.insertInvite + '?session_key=' + cookies.get('session_key'),
                data:{
                    inviteType: 2,
                    invitePhoneNumber: window.location.hash.split('?mobile=')[1]
                }
            }).then((res) => {
                console.log('拉新邀请', res);
                if(res.result === 'success'){
                }else{
                    // console.log(res)
                    if(res.code == '-1'){
                        cookies.remove('session_key');
                        cookies.remove('InvitationLoginMobile');
                        Toast.info('登录失效',1);
                    }else{
                        Toast.info('拉新邀请设置失败',1);
                    }
                }
            }, (res)=>{
                // console.log(res)
                if(res.code == '-1'){
                    cookies.remove('session_key');
                    cookies.remove('InvitationLoginMobile');
                    Toast.info('登录失效',1);
                }else{
                    Toast.info('拉新邀请设置失败',1);
                }
            });
        }
    }

    fx() {
        wxfx({
            title: '加入慧联租车，享”三优租车“服务',
            imgUrl: 'https://image.tf56.com/dfs/group1/M00/4E/78/CiFCK1-GUFeAc4IdAADrlgkZLDU935.png',
            desc: `您的好友${this.state.mobile.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2")}邀请您加入慧联租车`,
            url: `${window.location.origin}${window.location.pathname}#/InvitationOpen?mobile=${this.state.mobile}`
        })
    }

    render() {
        return (
            <div className="InvitationOpenBox">
                <img src={logoImg} style={{width: '1.5rem', padding: '0.2rem'}} />
                <div>您的好友 <span>{this.state.mobile.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2")}</span> 邀请您</div>
                <img src={contentImg} />
                <a className="XC" onClick={()=>{
                    if(cookies.get('session_key')){
                        href(`/MarketingOnlineIndex?mobile=${cookies.get('InvitationLoginMobile')}`);
                    }else{
                        this.setState({
                            loginType: true
                        });
                    }
                }}></a>
                {this.state.loginType ? (
                    <InvitationLogin
                        invitePhoneNumber={this.state.mobile}
                        onQuit={(loginType)=>{
                            this.setState({
                                loginType
                            });
                        }}
                    />
                ) : ''}
            </div>
        );
    }
}

export default InvitationOpen;


// WEBPACK FOOTER //
// ./src/invitation/invitationOpen/index.js